import {getAnalyticsTraceId} from '../../../common/utils';

export class SaveDiscountError extends Error {
  name = 'SaveDiscountError';
  code = 'save_discount_error';

  constructor(
    message: string,
    public analyticsTraceId: string = getAnalyticsTraceId(),
  ) {
    super(message);
  }
}
